"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cavriglia": {
    "d21967b0": [{
      "hkey": "86b83235",
      "slug": "cavriglia",
      "name": "Cavriglia",
      "primary": true,
      "skipSearch": false
    }],
    "campagna": [{
      "hkey": "86b83235",
      "slug": "cavriglia",
      "name": "Cavriglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "edb06937": [{
      "hkey": "59de25d4",
      "slug": "cetinale-san-cipriano-santa-barbara",
      "name": "Cetinale-San Cipriano-Santa Barbara",
      "primary": true,
      "skipSearch": false
    }],
    "cetinale": [{
      "hkey": "59de25d4",
      "slug": "cetinale-san-cipriano-santa-barbara",
      "name": "Cetinale-San Cipriano-Santa Barbara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "da108ff6": [{
      "hkey": "86b83235",
      "slug": "cavriglia",
      "name": "Cavriglia",
      "primary": true,
      "skipSearch": false
    }],
    "chiantigiana": [{
      "hkey": "86b83235",
      "slug": "cavriglia",
      "name": "Cavriglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d340f9fc": [{
      "hkey": "5cbfd22b",
      "slug": "neri-san-pancrazio",
      "name": "Neri-San Pancrazio",
      "primary": true,
      "skipSearch": false
    }],
    "neri": [{
      "hkey": "5cbfd22b",
      "slug": "neri-san-pancrazio",
      "name": "Neri-San Pancrazio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "52f3b3f1": [{
      "hkey": "59de25d4",
      "slug": "cetinale-san-cipriano-santa-barbara",
      "name": "Cetinale-San Cipriano-Santa Barbara",
      "primary": true,
      "skipSearch": false
    }],
    "san-cipriano": [{
      "hkey": "59de25d4",
      "slug": "cetinale-san-cipriano-santa-barbara",
      "name": "Cetinale-San Cipriano-Santa Barbara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cavriglia"
    }],
    "56fb9340": [{
      "hkey": "59de25d4",
      "slug": "cetinale-san-cipriano-santa-barbara",
      "name": "Cetinale-San Cipriano-Santa Barbara",
      "primary": true,
      "skipSearch": false
    }],
    "santa-barbara": [{
      "hkey": "59de25d4",
      "slug": "cetinale-san-cipriano-santa-barbara",
      "name": "Cetinale-San Cipriano-Santa Barbara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cavriglia"
    }]
  }
};
exports["default"] = _default;